export const IMAGES = {
  heroAmbient:
    "https://images.unsplash.com/photo-1531973968078-9bb02785f13d?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  gestionale: `${process.env.PUBLIC_URL}/images/gestionale.jpg`,
  team: `${process.env.PUBLIC_URL}/images/team.jpg`,
  kitchen: `${process.env.PUBLIC_URL}/images/kitchen.jpg`,
  bar: `${process.env.PUBLIC_URL}/images/bar.jpg`,
  saraKitchen:
    "https://images.pexels.com/photos/12935057/pexels-photo-12935057.jpeg?auto=compress&cs=tinysrgb&w=1600",
  saraSensing: `${process.env.PUBLIC_URL}/images/saraSensing.jpg`,
};
